export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const UPDATE_REGISTRATION_FORM_STATE = "UPDATE_REGISTRATION_FORM_STATE";
